export default __webpack_public_path__ + "static/session3-ad1539226cb20f6a0c3ab261fb1f310a.png";